import oyinkan from './oyinkan.jpg';
import yimika from './yimika.jpg';
import yemisi from './yemisi.jpg';
import temi from './temi.jpg';
import shalewa from './shalewa.jpg';


let borokinni = [
  {
    id: 1,
    name: "Yemisi Dress",
    image: yemisi,
    price: 45000,
  },
  {
    id: 2,
    name: "Yimika Jumpsuit",
    image: yimika,
    price: 36000,
  },
  {
    id: 3,
    name: "Temi Midi Dress",
    image: temi,
    price: 32000,
  },
  {
    id: 4,
    name: "Shalewa 2-piece",
    image: shalewa,
    price: 30000,
  },
  {
    id: 5,
    name: "Oyinkan",
    image: oyinkan,
    price: 25000,
  }
];
export default borokinni;
